import React, { useEffect, useState } from "react";
import { Api } from "../../api";
import axios from "axios";
import { Headers } from "../../api/actions";
import Loading from "../../components/loading/loading";
import { useParams } from "react-router";

import NavbarLeft from "../../components/navbar/navbar_left";
import NavbarTop from "../../components/navbar/navbar_top";
import QuestionContent from "./component/question-content";
import axiosInstance from "../../api/axios_instance";

const Question = () => {
  const { page, search, sortclassroom } = useParams();
  const pageCount = +page.slice(page.indexOf(":") + 1, page.length);
  const searchKeyword = search.slice(search.indexOf(":") + 1, search.length);
  const sortClassRoom = sortclassroom.slice(
    sortclassroom.indexOf(":") + 1,
    sortclassroom.length
  );
  const [perpage, setPerpage] = useState(0);
  const [data, setData] = useState([]);
  const [PageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);

  const ObJectArrayData = [
    {
      id: 2,
      href: `/questionbanck/page:${1}/search:${""}/sortclassroom:${""}`,
      title: "بنك الاسئلة",
    },
  ];

  useEffect(() => {
    GetData(
      setData,
      setLoading,
      pageCount,
      searchKeyword,
      sortClassRoom,
      setPerpage,
      PageSize
    );
  }, [pageCount, searchKeyword, sortClassRoom, PageSize]);

  if (!loading) {
    return (
      <section className="main">
        <NavbarLeft />
        <div className="main-body">
          <NavbarTop ArrayData={ObJectArrayData} />
          <div className="main-body__content">
            <Loading />
          </div>
        </div>
      </section>
    );
  }
  return (
    <section className="main">
      <NavbarLeft />
      <div className="main-body">
        <NavbarTop ArrayData={ObJectArrayData} />
        <div className="main-body__content">
          <QuestionContent
            ArrayData={data}
            perpage={perpage}
            pagenumber={pageCount}
            setLoading={setLoading}
            PageSize={PageSize}
            setPageSize={setPageSize}
          />
        </div>
      </div>
    </section>
  );
};

export default Question;

const GetData = async (
  setData,
  setLoading,
  pageCount,
  searchKeyword,
  sortClassRoom,
  setPerpage,
  PageSize
) => {
  var data = new FormData();
  data.append("pageNumber", pageCount);
  data.append("searchKeyword", searchKeyword);
  data.append("classRoomId", sortClassRoom === "" ? 0 : sortClassRoom);
  data.append("pageSize", PageSize);

  const options = {
    method: "post",
    url: `${Api}Subject/SearchQuestionBankSubjectList`,
    headers: Headers,
    data,
  };
  await axiosInstance(options)
    .then(function (response) {
      setData(response.data.responseObject.items);
      setLoading(true);

      setPerpage(
        Math.ceil(
          response.data.responseObject.totalItemsCount /
            response.data.responseObject.pageSize
        )
      );
    })
    .catch(function (error) {
      setLoading(true);
    });
};
